var _g, _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgHome02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 444,
    viewBox: "0 0 588 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_5015)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 588,
    height: 444,
    rx: 12,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 161,
    width: 133,
    height: 133,
    rx: 22,
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -105,
    y: 161,
    width: 133,
    height: 133,
    rx: 22,
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 161,
    width: 133,
    height: 133,
    rx: 22,
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 161,
    width: 133,
    height: 133,
    rx: 22,
    fill: "#F9FAFB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 143.323,
    width: 170,
    height: 170.384,
    rx: 22,
    fill: "#E5E7EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 143.323,
    width: 170,
    height: 170.384,
    rx: 22,
    fill: "url(#paint0_linear_66_5015)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.333 245.168C283.333 232.786 286.264 229.008 291.918 225.336C296.63 222.292 300.189 219.669 300.189 215.367C300.189 211.484 297.048 208.861 293.174 208.861C289.091 208.861 285.532 211.904 285.427 216.416H267C267.209 200.256 279.04 193.436 293.279 193.436C308.984 193.436 320.501 200.466 320.501 214.317C320.501 223.237 315.685 228.589 308.46 232.786C303.016 236.039 300.294 239.082 300.294 245.168V246.847H283.333V245.168ZM292.023 271.612C286.369 271.612 281.762 267.099 281.867 261.433C281.762 255.871 286.369 251.359 292.023 251.359C297.362 251.359 302.179 255.871 302.179 261.433C302.179 267.099 297.362 271.612 292.023 271.612Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.831 358.646C434.679 361.5 439.303 361.506 442.157 358.657C445.012 355.809 445.017 351.185 442.169 348.331L431.831 358.646ZM388.616 315.333L431.831 358.646L442.169 348.331L398.954 305.018L388.616 315.333Z",
    fill: "#3692FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.986 263.738C410.986 293.012 387.313 316.716 358.144 316.716C328.976 316.716 305.302 293.012 305.302 263.738C305.302 234.464 328.976 210.76 358.144 210.76C387.313 210.76 410.986 234.464 410.986 263.738Z",
    stroke: "black",
    strokeWidth: 14.6041
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_5015",
    x1: 236,
    y1: 150.84,
    x2: 357.369,
    y2: 325.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E7EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_5015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 588,
    height: 444,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHome02);
export default __webpack_public_path__ + "static/media/img_home_02.287baa985ee8ca42acc1c57c85bdfdd5.svg";
export { ForwardRef as ReactComponent };